export default __webpack_public_path__ + "static/media/fAbeNcake_w320.da658e47.jpeg";